import { useEffect } from 'react';

export default function SignedOutPage() {
  const reason = typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('reason')
    : null;

  const message = reason === 'oidc-correlation'
    ? 'Safari บล็อกคุกกี้ความปลอดภัยบางส่วน ทำให้ยืนยันการเข้าสู่ระบบไม่สำเร็จ กรุณากดเข้าสู่ระบบอีกครั้ง'
    : 'ออกจากระบบแล้ว';

  useEffect(() => {
    // Broadcast logout to any other open tabs via the storage event.
    // The storage event only fires in *other* tabs, not the one that set it.
    localStorage.setItem('app.logout', Date.now().toString());
  }, []);

  function handleLoginClick() {
    // The user is intentionally logging in again; clear the recent-logout marker
    // so AuthGuard does not bounce this tab back to /signed-out during callback.
    localStorage.removeItem('app.logout');
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: '1rem' }}>
      <p>{message}</p>
      <a href="/api/auth/login" onClick={handleLoginClick}>เข้าสู่ระบบ</a>
    </div>
  );
}
